module.exports = __webpack_public_path__ + "static/media/galleryGT (5).2fc131fe.jpg";